<template>
  <div class="d-flex justify-content-between">
    <h1>Verträge</h1>

    <button class="btn" @click="loadPage(page.pageIndex || 1)"><font-awesome-icon icon="rotate" /></button>
  </div>

  <div class="row mb-3">
    <div class="col-4">
      <router-link :to="{ name: 'EditVertrag' }" class="btn btn-primary"><font-awesome-icon icon="plus" /> Erstellen</router-link>
    </div>

    <div class="col-4">
      <div class="input-group input-group-sm my-auto">
        <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." @search="searchVertraege" />
        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="searchVertraege()">
          <font-awesome-icon icon="magnifying-glass" class="p-1" />
        </button>
      </div>
    </div>
  </div>

  <div v-if="!loading && errorMsg != ''" class="alert alert-danger mt-5">
    {{ errorMsg }}
    <!-- Es ist ein Fehler beim Laden der Vorlagen aufgetreten. Bite probieren Sie es später erneut. -->
  </div>

  <section>
    <div v-if="page.items.length > 0" class="mt-2">
      <div class="row mx-1 mb-2 bg-white shadow-sm">
        <div class="col-3 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Vertrag</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'titelasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'titeldesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('titelasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titelasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('titeldesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titeldesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-3 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Vertragspartner 1</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'vertragspartner1asc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'vertragspartner1desc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('vertragspartner1asc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'vertragspartner1asc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('vertragspartner1desc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'vertragspartner1desc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-3 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Vertragspartner 2</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'vertragspartner2asc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'vertragspartner2desc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('vertragspartner2asc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'vertragspartner2asc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('vertragspartner2desc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'vertragspartner2desc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-1 my-auto"><strong>Typ</strong></div>

        <div class="col-2 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Datum</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'datumasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'datumdesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('datumasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'datumasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('datumdesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'datumdesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <VertragRow v-for="vertrag in page.items" :key="vertrag.id" :vertrag="vertrag" />
    </div>

    <div v-else-if="!loading && errorMsg == '' && page.items.length == 0" class="alert alert-info mt-5">Es wurden keine Verträge gefunden.</div>

    <!-- Pagination -->
    <div class="row mx-0 mt-4">
      <div class="col-4 offset-4 my-auto">
        <nav v-if="page.totalPages > 1" aria-label="User pagination">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: !page.hasPrevious }">
              <button class="page-link" @click="goToPage(page.pageIndex - 1)" :disabled="!page.hasPrevious">
                <font-awesome-icon icon="chevron-left" />
              </button>
            </li>

            <li v-for="pageNr in pagesToShow" :key="pageNr" class="page-item" :class="{ active: pageNr === page.pageIndex }">
              <button class="page-link" @click="goToPage(pageNr)">
                {{ pageNr }}
              </button>
            </li>

            <li class="page-item" :class="{ disabled: !page.hasNext }">
              <button class="page-link" @click="goToPage(page.pageIndex + 1)" :disabled="!page.hasNext">
                <font-awesome-icon icon="chevron-right" />
              </button>
            </li>
          </ul>
        </nav>
      </div>

      <div class="col-4 my-auto d-flex justify-content-end align-items-center">
        <label class="form-label mb-0 me-2">Einträge pro Seite:</label>
        <select class="form-select d-inline-block w-auto" v-model.number="localPageSize" @change="changePageSize">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
    </div>
  </section>

  <LoadingOverlay v-if="loading" text="... Verträge werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VertragActionTypes } from '@/store/modules/Vertraege/actions';
  import { ActionTypes as VertragspartnerActionTypes } from '@/store/modules/Vertragspartner/actions';

  import LoadingOverlay from '@/components/LoadingOverlay.vue';
  import VertragRow from '@/components/Vertrag/VertragRow.vue';

  import { PagedRequest, SortDirection } from '@/models/CommonModels';
  //#endregion
  const store = useStore();

  const loading = computed(
    () => store.getters.status.getVertraegeLoading || store.getters.status.getVorlageLoading || store.getters.status.getPersonaldatenLoading
  );
  const errorMsg = computed(() => store.getters.status.vertragErrorMsg);

  //#region Paged
  const page = computed(() => store.state.vertraege.vertragPage);

  const pagesToShow = computed(() => {
    const maxPages = 5;
    const pages: number[] = [];

    let start = Math.max(1, page.value.pageIndex - Math.floor(maxPages / 2));
    let end = Math.min(page.value.totalPages, start + maxPages - 1);

    // ggf. Anfang anpassen, wenn wir am Ende sind
    if (end - start + 1 < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  });

  async function goToPage(pageIdx: number) {
    if (pageIdx < 1 || pageIdx > page.value.totalPages || pageIdx === page.value.pageIndex) return;
    await loadPage(pageIdx);
  }

  async function loadPage(pageIdx: number, size?: number) {
    const pagedRequest = {
      page: pageIdx,
      pageSize: size ?? localPageSize.value,
      sortBy: sortByParam.value,
      sortDirection: sortByDirection.value,
      filter: searchString.value,
    } as PagedRequest;

    await store.dispatch(VertragActionTypes.GetVertraegePage, pagedRequest);
  }

  function changePageSize() {
    // bei Änderung der PageSize auf Seite 1 springen
    loadPage(1, localPageSize.value);
  }

  const sortByValue = ref('datumdesc');
  const localPageSize = ref(page.value.pageSize);
  const sortByParam = ref('datum');
  const sortByDirection = ref(SortDirection.desc);
  const searchString = ref('');

  async function searchVertraege() {
    await loadPage(1);
  }

  async function sortBy(value: string) {
    sortByValue.value = value;

    sortByDirection.value = value.endsWith('asc') ? SortDirection.asc : SortDirection.desc;
    sortByParam.value = value.replace('asc', '').replace('desc', '');

    await loadPage(1);
  }

  //#endregion

  onMounted(async () => {
    await loadPage(page.value.pageIndex || 1);

    if (store.getters.vertragspartner.length == 0) {
      await store.dispatch(VertragspartnerActionTypes.GetVertragspartner, undefined);
    }
  });
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
